import axioPath from '../../../api/axioPath';
import { UPDATE_DATA } from 'redux/actions/action_types'
import { showAppLoader, hideAppLoader } from '../app';

export const appUserList = () => (dispatch) => {
  const token = localStorage.getItem("token")
  return axioPath
    .get('/users/dalancey-approvedList', {
      headers: {
        Authorization: token,
      },
    })
    .then((response) => {
      dispatch({ type: 'USER_MANAGEMENT_CUSTOMER_DETAILS', payload1: response.data?.newUserRequest });
      return response.data;
    })
    .catch((ex) => {
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};

export const palletSupplierToggleApiCall = (token, data) => (dispatch) => {
  return axioPath
    .post('/user/v2/internal/update_pallet_supplier', data, {
      headers: {
        Authorization: token,
      },
    })
    .then((response) => {
      return response;
    })
    .catch((ex) => {
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};

export const adminUserList = () => (dispatch) => {
  const token = localStorage.getItem("token")
  return axioPath
    .get('all-admins', {
      headers: {
        Authorization: token,
      },
    })
    .then((response) => {
      dispatch({ type: 'USER_MANAGEMENT_ADMIN_DETAILS', payload1: response.data });
      return response;
    })
    .catch((ex) => {
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};

export const addminNewUserList = (pageNumber, search, pageSize) => (dispatch) => {
  let totalpageSize = 10
  if (pageSize) {
    totalpageSize = pageSize
  }
  const token = localStorage.getItem("token")
  return axioPath
    .get(`users/dalancey-to-approvedList?pageStart=${pageNumber}&pageSize=${totalpageSize}&sort=DESC&searchBy=${search}`, {
      headers: {
        Authorization: token,
      },
    })
    .then((response) => {
      return response;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};

// store dashboard page informations 
export const setDashboardTableDetails = (value) => ({
  type: "DASH_TABLE_INFO_DETAILS",
  payload1: value,
});

export const setDashboardOrderGraphDetails = (value) => ({
  type: "DASH_ORDER_GRAPH_DETAILS",
  payload1: value,
});

export const setDashboardSubscriptionGraphDetails = (value) => ({
  type: "DASH_SUB_GRAPH_DETAILS",
  payload1: value,
});

export const setUserInfoDetails = (value) => ({
  type: "USERINFO_DETAILS_ADMIN",
  payload1: value,
});

export const newInvitationsList = (pageNumber, search) => (dispatch) => {
  dispatch(showAppLoader());
  const token = localStorage.getItem("token")
  let securityKey = process.env.REACT_APP_SECRET_KEY
  return axioPath
    .get(`welcome/all?startPage=${pageNumber}&pageSize=10&sort=DESC&searchBy=${search}`, {
      headers: {
        Authorization: token,
        secretKey: securityKey,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        1000
      );
      return response;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};

export const addminSubscriptionList = () => (dispatch) => {
  dispatch(showAppLoader());
  const token = localStorage.getItem("token")
  return axioPath
    .get('user/subscription/list', {
      headers: {
        Authorization: token,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        1000
      );
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};

export const adminClaimList = (fromDate, toDate, pageNumber, search) => (dispatch) => {
  dispatch(showAppLoader());
  let fromDateVal = Math.trunc(fromDate / 1000)
  let toDateVal = Math.trunc(toDate / 1000)
  const token = localStorage.getItem("token")
  return axioPath
    .get(`order/resolution/escalated_claim_list?pageNo=${pageNumber}&pageSize=10&sort=DESC&search=${search}&fromDate=${fromDateVal}&toDate=${toDateVal}`, {
      headers: {
        Authorization: token,
      },
    })
    .then((response) => {
      dispatch(hideAppLoader());
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};

export const adminClaimListforCount = () => () => {
  const token = localStorage.getItem("token")
  return axioPath
    .get('order/claim/rejected', {
      headers: {
        Authorization: token,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((ex) => {
      return ex;
    });
};

export const claimListNotification = () => () => {
  const token = localStorage.getItem("token")
  return axioPath
    .get('order/resolution_chat/check_new_msg', {
      headers: {
        Authorization: token,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((ex) => {
      return ex;
    });
};

export const updateClaimNotificationApi = () => () => {
  const token = localStorage.getItem("token")
  return axioPath
    .get('order/resolution_chat/update_new_msg', {
      headers: {
        Authorization: token,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((ex) => {
      return ex;
    });
}

export const adminResolvedClaimList = (fromDate, toDate, pageNumber, search) => (dispatch) => {
  dispatch(showAppLoader());
  let fromDateVal = Math.trunc(fromDate / 1000)
  let toDateVal = Math.trunc(toDate / 1000)
  const token = localStorage.getItem("token")
  return axioPath
    .get(`/order/resolution/admin_claim_resolved_list?pageNo=${pageNumber}&pageSize=10&sort=DESC&search=${search}&fromDate=${fromDateVal}&toDate=${toDateVal}`, {
      headers: {
        Authorization: token,
      },
    })
    .then((response) => {
      dispatch(hideAppLoader());
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};

export const adminCompletedOrderListforRefund = (fromDate, toDate, pageNumber, search) => (dispatch) => {
  dispatch(showAppLoader());
  let fromDateVal = Math.trunc(fromDate / 1000)
  let toDateVal = Math.trunc(toDate / 1000)
  const token = localStorage.getItem("token")
  return axioPath
    .get(`/order/resolution/completed_orders?pageNo=${pageNumber}&pageSize=10&sort=DESC&search=${search}&fromDate=${fromDateVal}&toDate=${toDateVal}`, {
      headers: {
        Authorization: token,
      },
    })
    .then((response) => {
      dispatch(hideAppLoader());
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};

export const adminRefundCompletedTrans = (fromDate, toDate, pageNumber, search) => (dispatch) => {
  dispatch(showAppLoader());
  let fromDateVal = Math.trunc(fromDate / 1000)
  let toDateVal = Math.trunc(toDate / 1000)
  const token = localStorage.getItem("token")
  return axioPath
    .get(`/order/resolution/adjustments_list?pageNo=${pageNumber}&pageSize=10&sort=DESC&search=${search}&fromDate=${fromDateVal}&toDate=${toDateVal}`, {
      headers: {
        Authorization: token,
      },
    })
    .then((response) => {
      dispatch(hideAppLoader());
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};

export const adminClaimFeeCalculate = (data) => () => {
  const token = localStorage.getItem("token")
  return axioPath
    .post('order/resolution/admin_calculate_fee', data, {
      headers: {
        Authorization: token,
      },
    }, data)
    .then((response) => {
      return response.data;
    })
    .catch((ex) => {
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};

export const adminClaimResolve = (data, token) => (dispatch) => {
  dispatch(showAppLoader())
  return axioPath
    .post('/order/resolution/admin_claim_resolved', data, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      dispatch(hideAppLoader());
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader())
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};

export const adminRefundResolve = (data, token) => (dispatch) => {
  dispatch(showAppLoader())
  return axioPath
    .post('/order/resolution/adjustments', data, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      dispatch(hideAppLoader());
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader())
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};

export const reverseSellerPayoutApi = (data, token) => (dispatch) => {
  dispatch(showAppLoader())
  return axioPath
    .post('/order/resolution/reverse-payout', data, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      dispatch(hideAppLoader());
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader())
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};

export const downloadInvoiceOrderById = (id, authIdVal, token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .get(`order/resolution/downloadinvoice?orderId=${id}&authId=${authIdVal}`, {
      headers: {
        Authorization: `${token}`,
        'Content-Type': "application/octet-stream"
      },
      responseType: 'blob',
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      return ex;
    });
};

export const downloadCreditMemoApiCall = (id, token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .get('/order/resolution/creditmemo?id=' + id, {
      headers: {
        Authorization: `${token}`,
        'Content-Type': "application/octet-stream"
      },
      responseType: 'blob',
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      return ex;
    });
};

export const contentModerationReviews = (userType) => (dispatch) => {
  dispatch(showAppLoader());
  const token = localStorage.getItem("token")
  return axioPath
    .get(`user/customer/reviews?userType=${userType}`, {
      headers: {
        Authorization: token,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        1000
      );
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};

export const addminUserActivityList = (data) => (dispatch) => {
  dispatch(showAppLoader());
  const token = localStorage.getItem("token")
  // let url = 'order/admin/user_activity_list'
  let url = "/order/v2/admin/user_activity_list"
  return axioPath.post(url, data, {
    headers: {
      Authorization: token,
    },
  }).then((response) => {
    setTimeout(
      () => {
        dispatch(hideAppLoader());
      },
      1000
    );
    return response;
  }).catch((ex) => {
    dispatch(hideAppLoader());
    if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
    else return ex;
  });
};

export const addminFetchLocationsList = (pageNumber, search, pageSize) => (dispatch) => {
  let totalpageSize = 10
  if (pageSize) {
    totalpageSize = pageSize
  }

  dispatch(showAppLoader());
  const token = localStorage.getItem("token")
  return axioPath
    .get(`user/location/locations?pageSize=${totalpageSize}&startPage=${pageNumber}&sort=DESC&searchBy=${search}`, {
      headers: {
        Authorization: token,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        1000
      );
      return response;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};

export const companyList = () => (dispatch) => {
  dispatch(showAppLoader());
  const token = localStorage.getItem("token")
  return axioPath
    .get(`user/admin/companyList`, {
      headers: {
        Authorization: token,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        1000
      );
      return response;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};

export const fetchOrderDetailsList = (pageNumber, typeOfOrderList) => (dispatch) => {
  const monthOptions = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
  let monthValue = monthOptions.indexOf(typeOfOrderList?.month) + 1
  if (monthValue < 10) monthValue = ("0" + monthValue)
  dispatch(showAppLoader());
  const token = localStorage.getItem("token")
  return axioPath
    .get(`order/admin/status/pageable?month=${monthValue}&year=${typeOfOrderList?.year}&sort=DESC&userType=${typeOfOrderList?.userType}&city=${typeOfOrderList?.city}&state=${typeOfOrderList?.state}&pageStart=${pageNumber}&pageSize=10&status=${typeOfOrderList?.typeOrder?.toUpperCase()}`, {
      headers: {
        Authorization: token,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        1000
      );
      return response;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};

export const addminPromoCodeList = () => (dispatch) => {
  dispatch(showAppLoader());
  const token = localStorage.getItem("token")
  let securityKey = process.env.REACT_APP_SECRET_KEY
  return axioPath
    .get('user/promocode', {
      headers: {
        Authorization: token,
        secretKey: securityKey
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        1000
      );
      return response;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};

export const addminCheckoutPromoCodeList = () => (dispatch) => {
  dispatch(showAppLoader());
  const token = localStorage.getItem("token")
  let securityKey = process.env.REACT_APP_SECRET_KEY
  return axioPath
    .get('user/newPromoCode/checkout_promo_list', {
      headers: {
        Authorization: token,
        secretKey: securityKey
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        1000
      );
      return response;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};

export const storeAdminDetails = (adminRoles, adminInfo) => ({
  type: "ADMIN_DETAILS",
  payload1: adminRoles,
  payload2: adminInfo
});

export const logoutAdmin = () => ({
  type: "ADMIN_LOGOUT",
});

//apis for referral page

export const updateReferralCodeStatusApi = (status) => (dispatch) => {
  dispatch(showAppLoader());
  const token = localStorage.getItem("token")
  return axioPath
    .post(`/user/referralcode/updateReferralCodesStatus?status=${status}`, {}, {
      headers: {
        Authorization: token,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        1000
      );
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};

export const getReferralCodeDetailsApi = () => (dispatch) => {
  dispatch(showAppLoader());
  const token = localStorage.getItem("token")
  let securityKey = process.env.REACT_APP_SECRET_KEY
  return axioPath
    .get('/user/referralcode/getReferralConfig', {
      headers: {
        Authorization: token,
        secretKey: securityKey,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        1000
      );
      return response;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};

export const updateReferralCodeDetailsApi = (data) => (dispatch) => {
  dispatch(showAppLoader());
  const token = localStorage.getItem("token")
  return axioPath
    .post('/user/referralcode/updateReferralConfig', data, {
      headers: {
        Authorization: token,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        1000
      );
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};

export const getIndividualReferralCodeDetailsApi = (code) => (dispatch) => {
  dispatch(showAppLoader());
  const token = localStorage.getItem("token")
  return axioPath
    .get(`/user/referralcode/getReferralCodeRecord?referralCode=${code}`, {
      headers: {
        Authorization: token,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        1000
      );
      return response;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};

// apis for new promocode actions

export const CreatePromoCodeApi = (data) => (dispatch) => {
  dispatch(showAppLoader());
  const token = localStorage.getItem("token")
  return axioPath
    .post(`/user/newPromoCode`, data, {
      headers: {
        Authorization: token,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        1000
      );
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};

export const AddPromoCodeforUserApi = (data) => (dispatch) => {
  dispatch(showAppLoader());
  const token = localStorage.getItem("token")
  return axioPath
    .post(`/user/newPromoCode/addNewPromoCode`, data, {
      headers: {
        Authorization: token,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        1000
      );
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};

export const AddExistingPromoCodeforUserApi = (data) => (dispatch) => {
  dispatch(showAppLoader());
  const token = localStorage.getItem("token")
  return axioPath
    .post(`/user/newPromoCode/addExistingPromoCode/`, data, {
      headers: {
        Authorization: token,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        1000
      );
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};

// apis for post need/inventory list

export const addminPostNeedList = (from, to) => (dispatch) => {
  dispatch(showAppLoader());
  const token = localStorage.getItem("token")
  let securityKey = process.env.REACT_APP_SECRET_KEY
  return axioPath
    .get(`users/postLoadInfoAdmin?fromDate=${from}&toDate=${to}`, {
      headers: {
        Authorization: token,
        secretKey: securityKey,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        1000
      );
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};

export const postVisibilityListV2 = (data) => (dispatch) => {
  dispatch(showAppLoader());
  const token = localStorage.getItem("token")
  return axioPath.post(`/rfp/v2/admin/post`, data, {
    headers: {
      Authorization: token,
    },
  })
    .then((response) => {
      dispatch(hideAppLoader());
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};

export const postAdminCommentV2 = (data) => (dispatch) => {
  dispatch(showAppLoader());
  const token = localStorage.getItem("token")
  return axioPath.post(`/rfp/v2/admin/post_comment`, data, {
    headers: {
      Authorization: token,
    },
  })
    .then((response) => {
      dispatch(hideAppLoader());
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};

export const postExport = (data) => (dispatch) => {
  dispatch(showAppLoader());
  const token = localStorage.getItem("token")
  return axioPath.post(`/rfp/admin/post_export`, data, {
    headers: {
      Authorization: token,
    },
  })
    .then((response) => {
      dispatch(hideAppLoader());
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      return ex;
    });
};

export const postVisibilityExportV2 = (data) => (dispatch) => {
  // dispatch(showAppLoader());
  const token = localStorage.getItem("token")
  return axioPath.post(`/rfp/v2/admin/post_export`, data, {
    headers: {
      Authorization: token,
    },
  })
    .then((response) => {
      // dispatch(hideAppLoader());
      return response.data;
    })
    .catch((ex) => {
      // dispatch(hideAppLoader());
      if (ex.response) return { error: true, data: ex.response?.data };
      return ex;
    });
};
export const addminPostInventoryList = (from, to) => () => {
  const token = localStorage.getItem("token")
  let securityKey = process.env.REACT_APP_SECRET_KEY
  return axioPath
    .get(`users/postInventoryInfoAdmin?fromDate=${from}&toDate=${to}`, {
      headers: {
        Authorization: token,
        secretKey: securityKey,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((ex) => {
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};

// apis for failed delivery orders
export const shippedFailedOrderList = (from, to) => () => {
  const token = localStorage.getItem("token")
  return axioPath
    .get(`order/admin/hold/list?sort=DESC&status=HOLD&fromDate=${from}&toDate=${to}&holdShippingStatus=SHIPPED`, {
      headers: {
        Authorization: token,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((ex) => {
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};
export const deliveredFailedOrderList = (from, to) => () => {
  const token = localStorage.getItem("token")
  return axioPath
    .get(`order/admin/hold/list?sort=DESC&status=HOLD&fromDate=${from}&toDate=${to}&holdShippingStatus=DELIVERED`, {
      headers: {
        Authorization: token,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((ex) => {
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};

// apis for all open orders
export const allOpenOrdersList = (pageSize, pageNo, search, from, to) => (dispatch) => {
  dispatch(showAppLoader());
  const token = localStorage.getItem("token")
  let searchValue = ''
  if (search) searchValue = search
  return axioPath
    .get(`order/admin/openorder/list?pageNo=${pageNo}&pageSize=${pageSize}&fromDate=${from}&toDate=${to}&search=${searchValue}`, {
      headers: {
        Authorization: token,
      },
    })
    .then((response) => {
      dispatch(hideAppLoader());
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};

// apis for all open orders
export const allCancelledOrdersList = (pageSize, pageNo, search, from, to) => (dispatch) => {
  dispatch(showAppLoader());
  const token = localStorage.getItem("token")
  let searchValue = ''
  if (search) searchValue = search
  return axioPath
    .get(`order/admin/cancelled/list?timeUnit=MONTH&timeVal=1&pageNo=${pageNo}&pageSize=${pageSize}&sort=DESC&search=${searchValue}&status=CANCELLED&deliveryRequirement=ALL&fromDate=${from}&toDate=${to}`, {
      headers: {
        Authorization: token,
      },
    })
    .then((response) => {
      dispatch(hideAppLoader());
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};

// chat support apis
export const fetchAllChatList = () => () => {
  const token = localStorage.getItem("token")
  return axioPath.get('/user/admin/chatMessageThreads', {
    headers: {
      Authorization: token,
    },
  })
    .then((response) => {
      return response.data;
    })
    .catch((ex) => {
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};

export const sendAdminChatMessage = (data) => () => {
  const token = localStorage.getItem("token")
  return axioPath.post('/user/chatMessage', data, {
    headers: {
      Authorization: token,
    },
  }).then((response) => {
    return response.data;
  }).catch((ex) => {
    if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
    else return ex;
  });
};

export const makeMessagesRead = (data) => () => {
  const token = localStorage.getItem("token")
  return axioPath.post(`/user/chatMessageThreadUpdateReadBy?userId=${data.userId}&userType=ADMIN`, {}, {
    headers: {
      Authorization: token,
    },
  }).then((response) => {
    return response.data;
  }).catch((ex) => {
    if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
    else return ex;
  });
};

//terms and conditions api
export const fetchTermsAndConditionsVersions = () => (dispatch) => {
  dispatch(showAppLoader());
  const token = localStorage.getItem("token")
  return axioPath
    .get('termsandconditions/findalltandc', {
      headers: {
        Authorization: token,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        1000
      );
      return response;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};

export const termsAndCondSaveDraft = (data) => (dispatch) => {
  dispatch(showAppLoader());
  const token = localStorage.getItem("token")
  return axioPath
    .post('termsandconditions/draf_tc', data, {
      headers: {
        Authorization: token,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        1000
      );
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};

export const termsAndCondPublishDraft = (id) => (dispatch) => {
  dispatch(showAppLoader());
  const token = localStorage.getItem("token")
  const adminAuthId = localStorage.getItem("adminAuthId")
  let url = `termsandconditions/update_tc?authId=${adminAuthId}&role=SUPER_ADMIN&tcId=${id}`
  return axioPath
    .post(url, {}, {
      headers: {
        Authorization: token,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        1000
      );
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};

export const termsAndCondDeleteVersion = (id) => (dispatch) => {
  dispatch(showAppLoader());
  const token = localStorage.getItem("token")
  const adminAuthId = localStorage.getItem("adminAuthId")
  let url = `termsandconditions/deletetc?authId=${adminAuthId}&role=SUPER_ADMIN&tcId=${id}`
  return axioPath
    .post(url, {}, {
      headers: {
        Authorization: token,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        1000
      );
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};

// quote
export const getQuoteListApi = (data, token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .post('rfp/quote/get', data, {
      headers: {
        Authorization: token,
      },
    })
    .then((response) => {
      dispatch(hideAppLoader());
      return response;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};

//quote notes
export const postQuoteNotes = (data) => (dispatch) => {
  dispatch(showAppLoader());
  const token = localStorage.getItem("token")
  return axioPath.post(`/rfp/quote/update_quote`, data, {
    headers: {
      Authorization: token,
    },
  })
    .then((response) => {
      dispatch(hideAppLoader());
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};
export const markQuote = (data) => (dispatch) => {
  dispatch(showAppLoader());
  const token = localStorage.getItem("token")
  return axioPath.post(`/rfp/quote/mark_quote`, data, {
    headers: {
      Authorization: token,
    },
  })
    .then((response) => {
      dispatch(hideAppLoader());
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};

// order chat apis
export const fetchAllOrderChatList = (token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath.get('/order/chat_list', {
    headers: {
      Authorization: `${token}`,
    },
  }).then((response) => {
    dispatch(hideAppLoader());
    return response.data;
  }).catch((ex) => {
    dispatch(hideAppLoader());
    if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
    else return ex;
  });
};

export const fetchMessagesByOrder = (token, id) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath.get(`/order/chat/${id}`, {
    headers: {
      Authorization: `${token}`,
    },
  }).then((response) => {
    dispatch(hideAppLoader());
    return response.data;
  }).catch((ex) => {
    dispatch(hideAppLoader());
    if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
    else return ex;
  });
};